import gql from 'graphql-tag';

// QUERIES

const getCouponPositionsQuery = gql`
  {
    positions: couponPositions {
      _id
      key
      name
    }
  }
`;

const getCouponsQuery = gql`
  query ($companyId: ObjectId!) {
    coupons: couponsInCompany(companyId: $companyId) {
      _id
      companyId
      imageURL
      discount
      smallTitle
      productLink
      terms
      description
      code
      position
      codeType
      estimatedSavings
      assessment {
        rating
        motivation
        expectedEffect
        profitability
        targetGroupAdaptation
        shouldShowAssessment
      }
      context
      usedCouponsResult {
        totalAmount
        booklets {
          _id
          amount
        }
      }
  }
}
`;

const couponCodeTypesQuery = gql`
  query CouponCodeTypes {
    couponCodeTypes
  }
`;

// MUTATIONS

const addCouponMutation = gql`
  mutation(
    $companyId: ObjectId!
    $imageURL: String
    $discount: String!
    $smallTitle: String!
    $productLink: String
    $terms: String
    $description: String
    $code: String
    $position: Int
    $codeType: String
    $estimatedSavings: Float
    $assessment: CouponAssessmentInput
    $context: String
    ) {
    createCoupon(
      companyId: $companyId
      imageURL: $imageURL
      discount: $discount
      smallTitle: $smallTitle
      productLink: $productLink
      terms: $terms
      description: $description
      code: $code
      position: $position
      codeType: $codeType
      estimatedSavings: $estimatedSavings
      assessment: $assessment
      context: $context
      ) {
        smallTitle
    }
  }
`;

const updateCouponMutation = gql`
  mutation(
    $_id: ObjectId!
    $imageURL: String
    $discount: String
    $smallTitle: String
    $productLink: String
    $terms: String
    $description: String
    $code: String
    $position: Int
    $codeType: String
    $estimatedSavings: Float
    $assessment: CouponAssessmentInput
    $context: String
    ) {
    updateCoupon(
      _id: $_id,
      imageURL: $imageURL
      discount: $discount
      smallTitle: $smallTitle
      productLink: $productLink
      terms: $terms
      description: $description
      code: $code
      position: $position
      codeType: $codeType
      estimatedSavings: $estimatedSavings
      assessment: $assessment
      context: $context
      ) {
        smallTitle
    }
  }
`;

const updateCouponPositionsMutation = gql`
  mutation UpdateCouponPositions($coupons: [UpdateCouponPositionInput!]!) {
    updateCouponPositions(newCoupons: $coupons) {
      _id
      position
    }
  }
`;

const normalizeCouponPositionsMutation = gql`
  mutation($companyId: ObjectId!) {
    normalizeCouponPositions(companyId: $companyId) {
      _id
      position
    }
  }
`

const generateCouponSuggestionsMutation = gql`
  mutation(
    $companyId: ObjectId!
    $quantity: Int!
    $contexts: [String]
    $context: String
    $couponId: ObjectId
    $regenerateType: RegenerateType
    $assessmentFields: [AssessmentField!]
    $existingCouponData: CouponInput
  ) {
    generateCouponSuggestions(
      companyId: $companyId
      quantity: $quantity
      contexts: $contexts
      context: $context
      couponId: $couponId
      regenerateType: $regenerateType
      assessmentFields: $assessmentFields
      existingCouponData: $existingCouponData
    ) {
      _id
      companyId
      imageURL
      discount
      smallTitle
      productLink
      terms
      description
      code
      position
      codeType
      estimatedSavings
      assessment {
        rating
        motivation
        expectedEffect
        profitability
        targetGroupAdaptation
        shouldShowAssessment
      }
      context
    }
  }
`;

export {
  getCouponPositionsQuery,
  getCouponsQuery,
  couponCodeTypesQuery,
  addCouponMutation,
  updateCouponMutation,
  updateCouponPositionsMutation,
  normalizeCouponPositionsMutation,
  generateCouponSuggestionsMutation
};
